import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { Calculator } from "Components/Merchant/FeeCalculator/Calculator";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { useResponsiveValue } from "Hooks/useResponsiveValue";
import { Resources, useResource } from "Translations/Resources";

export const MerchantFeeCalculatorPage = () => {
  return (
    <Layout>
      <Calculator />
    </Layout>
  );
};

const Layout = ({ children }: { children: React.ReactNode }) => {
  const getResponsiveValue = useResponsiveValue();
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      title={t(Resources.Pages.Titles.FeeCalculator)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: null, // "root" page, nowhere higher to go
      }}
    >
      <StyledPageWrapper
        maxWidth={getResponsiveValue([
          "600px !important",
          "600px !important",
          "600px !important",
          "850px !important",
          "unset !important",
        ])}
      >
        {children}
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default MerchantFeeCalculatorPage;
